export var ApplicationEnv;
(function (ApplicationEnv) {
    ApplicationEnv["LOCAL"] = "local";
    ApplicationEnv["PROD"] = "PROD";
})(ApplicationEnv || (ApplicationEnv = {}));
export var getEnv = function (key) {
    if (!process.env.hasOwnProperty(key)) {
        throw "Environment has no key ".concat(key);
    }
    return process.env[key];
};
export var getApiEndpoint = function () {
    return getEnv('REACT_APP_API_ENDPOINT');
};
export var apiUrl = function (url) {
    return getApiEndpoint() + url;
};
export var getApplicationEnv = function () {
    return getEnv('REACT_APP_ENV');
};
export var envIsLocal = function () { return getApplicationEnv() === ApplicationEnv.LOCAL; };
export var envIsProd = function () { return getApplicationEnv() === ApplicationEnv.PROD; };
